'use strict';

class ScrollInto{
  constructor(selector, callback, options){
    this.selector = selector

    this.options = typeof options == 'object' ? options : {};
    if(!this.options.hasOwnProperty('rootMargin')) {
      this.options.rootMargin = '-100px';
    }

    this.cb = callback;

    this.setupIntersectionObserver();
  }
  setupIntersectionObserver() {
      this.elements = [].slice.call(document.querySelectorAll(this.selector));
      if ('IntersectionObserver' in window) {
        let entryObserver = new IntersectionObserver(entries => {
          entries.forEach(entry => {
            if (entry.isIntersecting) {
              this.cb(entry.target);
              entryObserver.unobserve(entry.target);
            }
          });
        }, this.options);

        this.elements.forEach(el => {
          //el.classList.add('outside-view');
          entryObserver.observe(el);

        });
      } else {
        for (var i = this.elements.length - 1; i >= 0; i--) {
          this.cb(this.elements[i]);
        }
      }
  }

  waitForDOM(){
    document.addEventListener('DOMContentLoaded', this.ScrollInto.bind(this));
  }
}


export default ScrollInto;


// WEBPACK FOOTER //
// ./scripts/util/ScrollInto.js